import React, { useEffect, useState } from "react";
import {
  Typography,
  Row,
  Col,
  Breadcrumb,
  Space,
  Button,
  Dropdown,
  message,
  Card,
  Input,
  Collapse,
  Checkbox,
  Divider,
  Pagination,
  Select,
  Image,
} from "antd";
import { AppFooter } from "../LandingPage/Components/Footer/Footer";
import LogoGallery from "../LandingPage/Components/Logo/Logos";
import { useNotification } from "~/Hooks/useNotification";
import axios from "axios";
import type { MenuProps } from "antd";
import type { PaginationProps } from "antd";
import InvestImg from "@assets/KPMG/Invest.png";
import Infra from "@assets/KPMG/infra.png";
import InfratechMarketPlace from "@assets/KPMG/InfratechMarketPlace.png";
import {
  HomeOutlined,
  DownOutlined,
  PercentageOutlined,
  StarOutlined,
  EnvironmentOutlined,
  PlusOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { InvestmentHubData } from "~/mocks/MockData";
import DjuandaWater from "@assets/KPMG/assets/DjuandaWater.png";
import BinhDuong from "@assets/KPMG/assets/BinhDuong.png";
import plant from "@assets/KPMG/assets/plant.png";
import reserve from "@assets/KPMG/assets/reserve.png";
import ConnectingDots from "@assets/KPMG/connectingDots.svg";
import CircleInCircle from "@assets/KPMG/circleInCircle.svg";
import { Icon } from "@iconify/react";
import styles from "./InfratechMarketplace.module.scss";
import MainHeader from "../../Components/MainHeader/MainHeader";
import { TabInfo } from "../LandingPage/Components/MarketPlace/TabInfo";
import {
  mockData,
  mockDataMultiple,
} from "../LandingPage/Components/MarketPlace/mock";
import MarketingCard from "~/Components/MarketingCard/MarketingCard";
import { Fade } from "react-awesome-reveal";
import { BuildingProjects } from "./Components/BuildingProjects";
import { Title } from "../LandingPage/Components/Title/Title";
import SmartBuilding from "@assets/KPMG/infratech/SmartBuilding.svg";
import EV from "@assets/KPMG/infratech/EV.svg";
import SolarPanel from "@assets/KPMG/infratech/SolarPanel.svg";
import IconCheck from "@assets/KPMG/infratech/Charge+.jpg";
import Percent from "@assets/KPMG/percent.svg";
import Rating from "@assets/KPMG/rating.svg";
import Location from "@assets/KPMG/location.svg";

const getRandomImage = () => {
  const images = [DjuandaWater, BinhDuong, plant, reserve];
  const randomIndex = Math.floor(Math.random() * images.length);
  return images[randomIndex];
};

const { Search } = Input;
const { Panel } = Collapse;

const allProducts = [
  {
    title: "SMART BUILDING SOLUTIONS",
    description:
      "Transform your buildings into smarter and greener by bringing seamless connectivity from floor to floor. Harness the power of data collection to unlock valuable insights that will propel the business forward.",
    image: SmartBuilding,
    sectionBg: "#fff",
    background: "#F4F9FF",
    benefits: [
      {
        name: "Connected Building Packages",
        items: [
          "New Constructed Building",
          "Existing Building",
          "Retrofit Building",
        ],
      },
      {
        name: "On Demand",
        items: ["Building Assessment", "5G enablement", "Energy Management"],
      },
    ],
    projects: mockDataMultiple.projectList.filter(
      (item: any, index: number) => item.solution === "Smart Building Solutions"
    ),
  },
  {
    title: "SOLAR PANEL SOLUTIONS",
    description:
      "Transform your buildings into smarter and greener by bringing seamless connectivity from floor to floor. Harness the power of data collection to unlock valuable insights that will propel the business forward.",
    image: SolarPanel,
    sectionBg: "#F7FDFF",
    background: "#F7FDFF",
    benefits: [
      {
        name: "Solar Packages",
        items: [
          "New Constructed Building",
          "Existing Building",
          "Retrofit Building",
        ],
      },
      {
        name: "On Demand",
        items: ["Building Assessment", "5G enablement", "Energy Management"],
      },
    ],
    projects: mockDataMultiple.projectList.filter(
      (item: any) => item.solution && item.solution === "EV Solutions"
    ),
  },
  {
    title: "EV SOLUTIONS",
    description:
      "Transform your buildings into smarter and greener by bringing seamless connectivity from floor to floor. Harness the power of data collection to unlock valuable insights that will propel the business forward.",
    image: EV,
    sectionBg: "#fff",
    background: "#fff",
    benefits: [
      {
        name: "EV Packages",
        items: [
          "New Constructed Building",
          "Existing Building",
          "Retrofit Building",
        ],
      },
      {
        name: "On Demand",
        items: ["Building Assessment", "5G enablement", "Energy Management"],
      },
    ],
    projects: mockDataMultiple.projectList.filter(
      (item: any, index: number) =>
        item.solution && item.solution === "Solar Panel Solutions"
    ),
  },
];

export const InfratechMarketplace: React.FC = () => {
  const { openToast } = useNotification();
  const [data, setData] = useState<any>({});
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(8);
  const [checkData, setCheckData] = useState([]);
  const [selectData, setSelectData] = useState("");
  const totalItems = data.projectList?.length;
  const navigate = useNavigate();

  useEffect(() => {
    getRecords();
  }, []);

  const handlePageChange = (page: number, pageSize?: number) => {
    setCurrentPage(page);
    setPageSize(pageSize || 8);
  };

  const sample = [1, 2, 3, 4, 5, 6, 7, 8];
  const getRecords = async () => {
    // axios.get(``)
    //     .then((res: any) => {
    setData(mockDataMultiple);
    // })
    // .catch((err) => openToast({ content: err, type: "error" }))
  };
  const leadingBanks = (
    <Typography.Title level={5}>Leading Banks</Typography.Title>
  );

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    // message.info('Click on menu item.');
    console.log("click", e);
  };

  const items: MenuProps["items"] = [
    {
      label: "1st menu item",
      key: "1",
    },
    {
      label: "2nd menu item",
      key: "2",
    },
    {
      label: "3rd menu item",
      key: "3",
    },
    {
      label: "4rd menu item",
      key: "4",
    },
  ];

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const onSearch = (value: string) => console.log(value);

  const panelStyle = {
    marginBottom: 24,
    border: "none",
  };

  const itemRender: PaginationProps["itemRender"] = (
    _,
    type,
    originalElement
  ) => {
    if (type === "prev") {
      return "";
    }
    if (type === "next") {
      return (
        <a>
          <ArrowRightOutlined />
        </a>
      );
    }
    return originalElement;
  };

  return (
    <>
      <MainHeader
        title="INFRATECH MARKETPLACE"
        imageSrc={Infra}
        text={
          "Transform your buildings into smarter and greener by bringing seamless connectivity from floor to floor. Harness the power of data collection to unlock valuable insights that will propel the business forward."
        }
      />
      <div style={{ background: "#fff" }}>
        <Row justify="center">
          <Col lg={2}></Col>
          <Col lg={20} style={{ marginTop: "1.5rem" }}>
            <Breadcrumb>
              <Breadcrumb.Item>
                <Icon
                  icon="ic:outline-home"
                  height="20"
                  onClick={() => navigate("/")}
                  style={{
                    margin: "auto",
                    color: styles.strawberry,
                    cursor: "pointer",
                  }}
                />
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <a onClick={() => navigate("/infratech-marketplace")}>
                  Infratech Marketplace
                </a>
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          <Col lg={2}></Col>
        </Row>

        <div>
          {allProducts.map((product: any, index: number) => (
            <Row
              style={{
                background: product.sectionBg,
              }}
              key={index}
            >
              <Col span={2}></Col>
              <Col span={20}>
                <div
                  key={index}
                  style={{
                    paddingTop: 40,
                    paddingBottom: 40,
                  }}
                >
                  <Title title={product.title} width={1200} />
                  <div
                    style={{
                      background: product.background, //#F4F9FF
                      borderRadius: "0px 293.5px 0px 0px",
                      padding: 20,
                    }}
                  >
                    <div style={{ paddingRight: 150 }}>
                      <Typography.Text
                        className="text"
                        style={{ color: "#003087" }}
                      >
                        {product.description}
                      </Typography.Text>
                    </div>
                    <Row
                      style={{
                        paddingTop: 20,
                        paddingBottom: 20,
                        marginRight: -40,
                      }}
                    >
                      <Col span={18}>
                        <img src={product.image} style={{ maxWidth: 800 }} />
                      </Col>
                      <Col span={6}>
                        <div
                          style={{
                            width: "100%",
                            background: "#003087",
                            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.15)",
                            padding: "0 30px",
                            paddingBottom: 30,
                            // marginRight: -40,
                          }}
                        >
                          {product.benefits.map((benefit: any, i: number) => (
                            <div key={`benefit${i}`} style={{ paddingTop: 20 }}>
                              <Typography.Title
                                level={5}
                                style={{
                                  color: "#FD349C",
                                  paddingTop: 10,
                                  paddingBottom: 0,
                                }}
                              >
                                {benefit.name}
                              </Typography.Title>
                              {benefit.items.map((bItem: any, j: number) => (
                                <div
                                  key={`bItems${j}`}
                                  style={{
                                    paddingBottom: 8,
                                    paddingTop: 8,
                                    borderBottom: "1px solid #fff",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {i > 0 && (
                                      <div style={{ marginRight: 10 }}>
                                        <Icon
                                          icon={"charm:circle-tick"}
                                          fontSize={20}
                                          style={{ color: "white" }}
                                        />
                                      </div>
                                    )}
                                    <div>
                                      <Typography.Text
                                        style={{ color: "#fff" }}
                                      >
                                        {bItem}
                                      </Typography.Text>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ))}
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div style={{ paddingTop: 20 }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        borderBottom: "1px solid #979797",
                        marginBottom: 20,
                      }}
                    >
                      <div>
                        <Typography.Title level={5}>
                          Most Popular Products
                        </Typography.Title>
                      </div>
                      <div>
                        <Typography.Link
                          onClick={() =>
                            navigate("/infratech-marketplace/list")
                          }
                          style={{
                            color: "#003087",
                            fontSize: 14,
                            // textDecoration: "underline",
                          }}
                        >
                          View All
                        </Typography.Link>
                      </div>
                    </div>
                    <Row gutter={[16, 16]}>
                      {product.projects.map((project: any, pIndex: number) => (
                        <Col
                          span={8}
                          key={`pIndex${pIndex}`}
                          style={{ display: pIndex < 3 ? "block" : "none" }}
                        >
                          <div
                            style={{
                              height: "100%",
                              background: "#FFFFFF",
                              boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.25)",
                              borderRadius: 26,
                              padding: 20,
                            }}
                          >
                            <Row gutter={[16, 0]}>
                              <Col span={8}>
                                <img
                                  src={project.categoryIcon}
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: 120,
                                  }}
                                />
                              </Col>
                              <Col span={16}>
                                <Fade triggerOnce cascade damping={0.1}>
                                  <Typography.Title
                                    onClick={() =>
                                      navigate(
                                        `/infratech-marketplace/view/${project.id}`
                                      )
                                    }
                                    level={5}
                                    style={{
                                      marginBottom: 20,
                                      cursor: "pointer",
                                    }}
                                  >
                                    {project.title}
                                  </Typography.Title>
                                  <div
                                    style={{
                                      marginBottom: 20,
                                    }}
                                  >
                                    <div style={{ display: "flex" }}>
                                      <Image src={Percent} preview={false} />
                                      <Typography.Text
                                        style={{
                                          marginLeft: 10,
                                          color: "#1E49E2",
                                        }}
                                      >
                                        {project.category}
                                      </Typography.Text>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                      }}
                                    >
                                      <Image src={Location} preview={false} />
                                      <Typography.Text
                                        style={{
                                          marginLeft: 10,
                                          color: "#1E49E2",
                                        }}
                                      >
                                        {project.location}
                                      </Typography.Text>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                      }}
                                    >
                                      <Image src={Rating} preview={false} />
                                      <Typography.Text
                                        style={{
                                          marginLeft: 10,
                                          color: "#1E49E2",
                                        }}
                                      >
                                        {project.rating}
                                      </Typography.Text>
                                    </div>
                                  </div>
                                </Fade>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </div>
              </Col>
              <Col span={2}></Col>
            </Row>
          ))}
        </div>
      </div>
      <LogoGallery element={leadingBanks} />
      <AppFooter />
    </>
  );
};
